import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

import person1 from '../assets/images/team-person1.jpg';
import person2 from '../assets/images/team-person2.jpg';
import person3 from '../assets/images/team-person3.jpg';
import person4 from '../assets/images/team-person4.jpg';

const Team = () => {
    const { t } = useTranslation();
    const teamMembers = [
        { img: person1, name: t('team_member1_name'), title: t('team_member1_title') },
        { img: person2, name: t('team_member2_name'), title: t('team_member2_title') },
        { img: person3, name: t('team_member3_name'), title: t('team_member3_title') },
        { img: person4, name: t('team_member4_name'), title: t('team_member4_title') },
    ];

    return (
        <section className="float-left w-100 our-team-con position-relative padding-top main-box text-center">
            <Container className="wow animate__animated animate__fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
                <div className="heading-title-con text-center">
                    <span className="special-text color-blue d-block">{t('team_tag')}</span>
                    <h2 dangerouslySetInnerHTML={{ __html: t('team_title') }}></h2>
                </div>
                <Row className="all_row">
                    {teamMembers.map((member, index) => (
                        <Col lg={3} md={6} className="all_column wow animate__animated animate__fadeInDown" data-wow-duration="2s" data-wow-delay={`${0.2 + index * 0.1}s`} key={index}>
                            <div className="team-box all_boxes">
                                <figure className="mb-0"><img src={member.img} alt={member.name} className="img-fluid" /></figure>
                                <h5>{member.name}</h5>
                                <span className="d-block">{member.title}</span>
                                <ul className="list-unstyled mb-0 social-icons">
                                    <li><a href="https://www.facebook.com/" className="text-decoration-none"><FontAwesomeIcon icon={faFacebookF} /></a></li>
                                    <li><a href="https://www.instagram.com/" className="text-decoration-none"><FontAwesomeIcon icon={faInstagram} /></a></li>
                                    <li><a href="https://www.linkedin.com/" className="text-decoration-none"><FontAwesomeIcon icon={faLinkedinIn} /></a></li>
                                </ul>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default Team;